import typeOfOperand from "@tinqin/tinqin-utils/src/base/typeOfOperand";
import webui from "../app/InternalStateService";
import { getDependentPaths } from "./storeUtils";

//TODO deprecate?
export function createJSONData(
    json,
    sirenAction = {},
    requestEntityPath = "",
    multipart = false,
    parser
) {
    let payload = {
        action: {
            id: sirenAction.id,
            actionType: sirenAction.actionType,
            parameters: sirenAction.parameters
        },
        content: {}
    };
    let files = [];
    let sanitizeData = sanitizePayload.apply(files, [Object.assign({}, json)]);

    if (requestEntityPath) {
        payload.content[requestEntityPath] = sanitizeData;
    } else {
        payload.content = sanitizeData;
    }

    if (multipart) {
        let formData = new FormData();

        if (parser) {
            payload = parser(json);
        }

        formData.append("json", JSON.stringify(payload));

        if (files && files.length) {
            files.forEach(fileObj => {
                formData.append(fileObj.fieldName, fileObj.file, fileObj.file.name);
            });
        }

        return formData;
    }

    return payload;
}

export function createData(json, sirenAction = {}, options) {
    let { currentWidgetId, sources, parser, singleEntityInRequestBody } = options;
    // init
    let sanitizeData;
    let requestEntity;
    let files = [];
    let payload = {
        action: {
            id: sirenAction.id,
            actionType: sirenAction.actionType,
            parameters: sirenAction.parameters,
            fields: sirenAction.fields
        },
        content: {}
    };

    // json or form/data
    let contentType = sirenAction.type || sirenAction.contentType || "application/json";
    let multipart = contentType.indexOf("application/json") === -1; // multipart/form-data

    // single
    if (json.length === 1) {
        requestEntity = json[0].entities[0];
        sanitizeData = sanitizePayload.apply(files, [
            Object.assign({}, requestEntity),
            currentWidgetId
        ]);
        if (singleEntityInRequestBody) {
            payload.content = sanitizeData;
        } else {
            payload.content[sources[0]] = sanitizeData;
        }
    } else {
        // multiple
        requestEntity = {
            class: ["request"],
            entities: json
        };
        sanitizeData = sanitizePayload.apply(files, [
            Object.assign({}, requestEntity),
            currentWidgetId
        ]);

        let entities = sanitizeData.entities;
        for (let i = 0; i < entities.length; i++) {
            let entity = entities[i];
            let firstClass = entity.class[0];
            payload.content[firstClass] = entity.entities[0];
        }
    }

    if (parser) {
        payload = parser(payload);
    }

    if (multipart) {
        let formData = new FormData();

        formData.append("json", JSON.stringify(payload));

        if (files && files.length) {
            files.forEach(fileObj => {
                formData.append(fileObj.fieldName, fileObj.file, fileObj.file.name);
            });
        }

        return formData;
    } else {
        return payload;
    }
}

export function createFormData(json, sirenAction = {}, parser, widgetId) {
    let files = [];
    let formData = new FormData();
    let payload;
    if (parser) {
        payload = parser(json);
    } else {
        payload = sanitizePayload.apply(files, [Object.assign({}, json), widgetId]);
    }
    formData.append("json", JSON.stringify(payload));

    if (files && files.length) {
        files.forEach(fileObj => {
            formData.append(fileObj.fieldName, fileObj.file, fileObj.file.name);
        });
    }

    //adding action parameters to formData
    if (sirenAction.parameters) {
        formData.append("parameters", JSON.stringify(sirenAction.parameters));
    }
    //adding action type to formData
    if (sirenAction.actionType) {
        formData.append("action", sirenAction.actionType);
    }
    //adding action Id to formData
    if (sirenAction.id) {
        formData.append("actionId", sirenAction.id);
    }
    //adding action Fields to formData
    if (sirenAction.fields) {
        formData.append("actionFields", JSON.stringify(sirenAction.fields));
    }
    return formData;
}

export function sanitizePayload(payload, widgetId) {
    let serializeMethod = webui.getSerializeMethod({ widgetId });
    if (serializeMethod) {
        return serializeMethod.apply(this, [payload, widgetId]);
    } else {
        return serializeEntityStandard.apply(this, [payload, widgetId]);
    }
}

export function serializeEntityStandard(payload, widgetId) {
    // Skipping data sanitize for particular entity and its decedents if needed.
    if (payload.class && payload.class.length && payload.class.includes("skipDataSanitize")) {
        return payload;
    }

    let entityClass = payload.class || [];
    let payloadEntities = payload.entities;
    let isSingleEnum = entityClass.includes("enum");
    let isMultiEnum = entityClass.includes("multiEnum");
    let isContainer = entityClass.includes("container");
    let isAutosuggest = entityClass.includes("autosuggest");

    let result = {
        class: entityClass
    };

    //multi enum components sanitize
    if (isMultiEnum) {
        return sanitizePayloadMultiEnum(payload, result);
    }
    //single components sanitize
    if (isSingleEnum || !payloadEntities) {
        return sanitizePayloadStatic.apply(this, [payload, result]);
    }
    //autosuggest Dropdown sanitize
    if (isAutosuggest) {
        return sanitizeAutosuggest(payload, result);
    }

    //container contains the logic to submit or not children entities data
    if (isContainer) {
        return sanitizeContainerPayload(payload, payloadEntities, result, widgetId);
    }
    //check for entities
    if (payloadEntities && Array.isArray(payloadEntities)) {
        sanitizePayloadStatic.apply(this, [payload, result]);
        result = sanitizePayloadEntities.apply(this, [payloadEntities, result, widgetId]);
    }
    //check for files
    return sanitizePayloadFile.apply(this, [result]);
}

function sanitizeContainerPayload(payload, payloadEntities, result, widgetId) {
    let payloadProperties = payload.properties || {};
    //submit data - always && never are not dependant by the "visible" true, false property;
    //default is visible -  submit data if "visible": true
    let submitData = payloadProperties.submitData || "visible";
    if (submitData === "always") {
        return sanitizePayloadEntities.apply(this, [payloadEntities, result, widgetId]);
    }
    //default visible: true
    let visible = payloadProperties.hasOwnProperty("visible") ? payloadProperties.visible : true;
    if (visible && submitData === "visible") {
        return sanitizePayloadEntities.apply(this, [payloadEntities, result, widgetId]);
    }

    return result;
}

function sanitizePayloadFile(result, payload = {}) {
    let properties = result.properties || {};
    let files = properties.value && properties.value.files;

    if (files && Array.isArray(this)) {
        result.properties.value.files.forEach(file => {
            let fieldName = payload.class[0];
            let payloadProperties = payload.properties || {};
            if (payloadProperties.fieldName) {
                fieldName = payload.properties.fieldName;
            }
            // ignore objects that are not files (have only metadata)
            if (typeOfOperand(file) === "file") {
                this.push({ fieldName: fieldName, file: file });
            }
        });
    }
    result = addServerParameters(payload, result);
    return addFailedValidations(result, result);
}

function sanitizePayloadStatic(payload, result) {
    let value = null;
    let letStoreValue;

    if (payload.properties) {
        letStoreValue = payload.properties.value;
        if (letStoreValue !== undefined && letStoreValue !== "") {
            value = payload.properties.value;
        }

        result.properties = {};

        result.properties.value = value;
    }

    result = addServerParameters(payload, result);
    result = addFailedValidations(payload, result);

    return sanitizePayloadFile.apply(this, [result, payload]);
}

function sanitizePayloadMultiEnum(payload, result) {
    let value = [];
    let letStoreValues = payload.properties && payload.properties.value;
    if (letStoreValues) {
        value = payload.properties.value;
        result.properties = {};
        result.properties.value = value;
    }

    result = addServerParameters(payload, result);
    return addFailedValidations(payload, result);
}

function sanitizeAutosuggest(payload, result) {
    //TODO: consider if we can use multiEnum here? Dropdown autosuggestion seems to be enumerable and can be multiselection.
    if (payload.properties) {
        result.properties = {};
        if (payload.properties.hasOwnProperty("value")) {
            result.properties.value = payload.properties.value;
        }
        if (payload.properties.hasOwnProperty("suggestionValue")) {
            result.properties.suggestionValue = payload.properties.suggestionValue;
        }
    }
    result = addServerParameters(payload, result);
    return addFailedValidations(payload, result);
}

function sanitizePayloadEntities(payloadEntities = [], result, widgetId) {
    result.entities = [];

    payloadEntities.forEach(subEntity => {
        let toPush;

        //some entities can be marked and skipped in request payload
        if (subEntity.class && subEntity.class.includes("skip")) {
            return;
        }

        toPush = {
            class: subEntity.class
        };
        if (subEntity.entities) {
            toPush.entities = subEntity.entities;
        }
        if (subEntity.properties) {
            toPush.properties = subEntity.properties;
        }

        if (subEntity.failedValidations) {
            toPush.failedValidations = subEntity.failedValidations;
        }
        if (subEntity.parameters) {
            toPush.parameters = subEntity.parameters;
        }
        result.entities.push(sanitizePayload.apply(this, [toPush, widgetId]));
    });

    return result;
}

function addFailedValidations(payload, result) {
    if (payload.failedValidations) {
        result.failedValidations = payload.failedValidations;
    }

    return result;
}

function addServerParameters(payload, result) {
    if (payload.parameters) {
        result.parameters = payload.parameters;
    }

    return result;
}

export function constructRequestEntity(
    sources,
    state,
    currentPath,
    sirenAction,
    currentWidgetId,
    options = {}
) {
    let constructRequestEntityMethod = webui.getConstructRequestEntityMethod({ currentWidgetId });
    if (constructRequestEntityMethod) {
        return constructRequestEntityMethod.apply(this, [
            sources,
            state,
            currentPath,
            sirenAction,
            currentWidgetId,
            options
        ]);
    } else {
        return constructRequestEntityStandard.apply(this, [
            sources,
            state,
            currentPath,
            sirenAction,
            currentWidgetId,
            options
        ]);
    }
}

export function constructRequestEntityStandard(
    sources,
    state,
    currentPath,
    sirenAction,
    currentWidgetId,
    options = {}
) {
    if (!sources.length) {
        return {
            action: {
                id: sirenAction.id,
                actionType: sirenAction.actionType,
                parameters: sirenAction.parameters
            },
            content: {}
        };
    }

    let extractedEntities = sources.map(dependency => {
        let dependentPaths = getDependentPaths([dependency], state, currentPath, currentWidgetId);
        return {
            class: [dependency], //TODO consider using resolved path here
            entities: dependentPaths.map(dependentStorePath => {
                let result = state.getIn(["data", ...dependentStorePath]);
                return result ? result.toJS() : null;
            })
        };
    });

    return createData(extractedEntities, sirenAction, {
        currentWidgetId,
        sources,
        parser: webui.getActionByName("widget.getOutputParser")(currentWidgetId, state),
        singleEntityInRequestBody: options.singleEntityInRequestBody
    });
}
